import { createSlice } from "@reduxjs/toolkit";

interface AppState {
  isSidebarOpen: boolean;
}

const initialState: AppState = {
  isSidebarOpen: false,
};

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    //create your actions creator
    toggleSidebar: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
    collapseSidebar: (state) => {
      if (state.isSidebarOpen === true) state.isSidebarOpen = false;
    },
  },
});

//return the actions
export const { toggleSidebar, collapseSidebar } = sidebarSlice.actions;

//exporting the reducer
export default sidebarSlice.reducer;
